














import { Component, Vue } from 'vue-property-decorator';
import { mfCarregandoEvento } from '@/constants';

@Component ({})
export default class Carregando extends Vue {

  exibir = false;
  msg = '';

  mounted() {
    document.addEventListener(mfCarregandoEvento.EXIBIR_CARREGANDO, (e) => {
      const customEvent = e as CustomEvent;
      if (customEvent.detail && customEvent.detail.msg) {
        this.msg = customEvent.detail.msg;
      }
      this.exibir = true;
    }, false);

    document.addEventListener(mfCarregandoEvento.ESCONDER_CARREGANDO, () => {
      this.exibir = false;
      this.msg = '';
    }, false);
  }
}
